// extracted by mini-css-extract-plugin
export default {"container":"DeleteBranch_container__J64sV","boxModal":"DeleteBranch_boxModal__I3kT4","boxBtn":"DeleteBranch_boxBtn__y13Sy"};